import React, { useEffect, useRef, useState } from 'react';
import api from '../../plugins/api';
import Button from '../Button/Button';

// Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¶Ð¸Ð²ÑÑ ~5 Ð¼Ð¸Ð½ÑÑ â ÑÑÐ¾Ð»ÑÐºÐ¾ Ð¶Ðµ Ð¾Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼
const POLL_INTERVAL = 5000;
const POLL_LIMIT = 60;

const GbdflRequest = ({ clientId, onUpdated }) => {
  const [status, setStatus] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const [available, setAvailable] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    api
      .get('/api/crm/clients/gbdfl/available')
      .then(({ data }) => setAvailable(!!data?.available))
      .catch(() => setAvailable(false));
    return () => clearTimeout(timer.current);
  }, []);

  const poll = async (requestId, attempt) => {
    try {
      const { data: res } = await api.post(
        `/api/crm/clients/${clientId}/gbdfl/poll?requestId=${requestId}`
      );
      if (res?.ready) {
        setWaiting(false);
        setStatus({
          type: 'success',
          text: res.message || 'ÐÐ°Ð½Ð½ÑÐµ Ð¿Ð¾Ð»ÑÑÐµÐ½Ñ',
          fields: res.updatedFields,
        });
        onUpdated && onUpdated();
        return;
      }
      if (res?.finished) {
        setWaiting(false);
        setStatus({ type: 'error', text: res.message || 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ðµ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¾' });
        return;
      }
    } catch (e) {
      setWaiting(false);
      setStatus({ type: 'error', text: e?.response?.data?.errorMessage || 'ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð¿ÑÐ¾ÑÐ° Ð² ÐÐÐ' });
      return;
    }

    if (attempt >= POLL_LIMIT) {
      setWaiting(false);
      setStatus({
        type: 'error',
        text: 'ÐÐ»Ð¸ÐµÐ½Ñ Ð½Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸Ð» ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð·Ð° 5 Ð¼Ð¸Ð½ÑÑ. ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ Ð²ÑÑÑÐ½ÑÑ Ð¸Ð»Ð¸ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÐµ Ð·Ð°Ð¿ÑÐ¾Ñ.',
      });
      return;
    }
    timer.current = setTimeout(() => poll(requestId, attempt + 1), POLL_INTERVAL);
  };

  const request = async () => {
    setStatus(null);
    setWaiting(true);
    try {
      const { data: res } = await api.post(`/api/crm/clients/${clientId}/gbdfl/request`);
      setStatus({
        type: 'pending',
        text: 'ÐÐ»Ð¸ÐµÐ½ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð¡ÐÐ¡. ÐÐ»Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð¾Ð½ Ð¾ÑÐ²ÐµÑÐ°ÐµÑ 511, Ð´Ð»Ñ Ð¾ÑÐºÐ°Ð·Ð° â 512.',
      });
      timer.current = setTimeout(() => poll(res.requestId, 1), POLL_INTERVAL);
    } catch (e) {
      setWaiting(false);
      setStatus({ type: 'error', text: e?.response?.data?.errorMessage || 'ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð¿ÑÐ¾ÑÐ° Ð² ÐÐÐ' });
    }
  };

  const colors = { pending: '#6A6A6A', success: '#349D64', error: '#EE7171' };

  if (!available) return null;

  return (
    <div style={{ marginTop: 15 }}>
      <Button
        text={waiting ? 'ÐÐ¶Ð¸Ð´Ð°ÐµÐ¼ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°â¦' : 'ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð¸Ð· ÐÐÐ Ð¤Ð'}
        fill
        full
        disabled={waiting}
        onClick={request}
      />
      {status && (
        <p style={{ color: colors[status.type], fontSize: 13, marginTop: 8, lineHeight: 1.3 }}>
          {status.text}
          {status.fields?.length > 0 && (
            <span style={{ display: 'block', color: '#6A6A6A', marginTop: 4 }}>
              ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾: {status.fields.join(', ')}
            </span>
          )}
        </p>
      )}
    </div>
  );
};

export default GbdflRequest;
